export default __webpack_public_path__ + "static/media/Lc.c104a078.jpeg";